import React from 'react';
import SectionHeading from './SectionHeading';

const ContactForm1 = () => {
    return (
        <div className="contact-form drop-shadow-2">
            <div className="contact-form-wrapper">
                <SectionHeading
                    icon='las la-envelope'
                    heading='Business Opportunities'
                    subHeading='Join the Natural Wellness Revolution'
                    additionalClasses='section-heading-2 center'
                />
                <div style={{ height: '674px', width: '100%' }}>
                    <iframe
                        src="https://api.amazon-andes.com/widget/form/Pr9wJSUT8bYDkfgC68mS"
                        style={{ width: '100%', height: '100%', border: 'none', borderRadius: '3px' }}
                        id="inline-Pr9wJSUT8bYDkfgC68mS"
                        data-layout='{"id":"INLINE"}'
                        data-trigger-type="alwaysShow"
                        data-trigger-value=""
                        data-activation-type="alwaysActivated"
                        data-activation-value=""
                        data-deactivation-type="neverDeactivate"
                        data-deactivation-value=""
                        data-form-name="Contacto Web | red maca landing V2"
                        data-height="674"
                        data-layout-iframe-id="inline-Pr9wJSUT8bYDkfgC68mS"
                        data-form-id="Pr9wJSUT8bYDkfgC68mS"
                        title="Contacto Web | red maca landing V2"
                    />
                </div>
                <script src="https://api.amazon-andes.com/js/form_embed.js" />
            </div>
        </div>
    );
};

export default ContactForm1;
